import React, { FC, useRef } from 'react';

import { Box, Button, Center, Flex, Heading, Text } from '@chakra-ui/react';

import { MdFileUpload } from 'react-icons/md';

import { washHub } from 'store/slices';
import { useNavigate } from 'react-router-dom';

import { UserPill } from 'components/core/UserPill';
import { DataTable } from 'components/modules/DataTable';

import { scansColumns } from './scansColumns';

import { exportScansCsv } from 'api/items';
import { useMutation } from 'react-query';

import { CSVLink } from 'react-csv';

import { Scan } from 'types/items';
import { ScansViewProps } from './Scans.props';
import { Filters } from 'components/primitives/Filters';
import { StatCards } from 'components/primitives/StatCards';
import { DateRangeInputExt } from 'components/modules/DateRangeInputExt';

const ScansView: FC<ScansViewProps> = (props) => {
  const navigate = useNavigate();
  const csvRef = useRef<any>(null);

  const selectedWashHub = washHub.selectors.useSelectedWashHub();
  const washHubId = selectedWashHub?._id || '';

  const {
    sku,
    site,
    venue,
    scans,
    status,
    isLoading,
    pagination,
    endDate,
    startDate,
    setStatus,
    onSearchClear,
    onSearchPress,
    onApplyFilters,
    onClearFilters,
  } = props;

  const { mutate, data = '', isLoading: isExporting } = useMutation(
    async () =>
      exportScansCsv({
        washHub: washHubId,
        status,
        sku,
        site,
        endDate,
        startDate,
      }),
    {
      onSuccess: () => {
        setTimeout(() => {
          csvRef.current?.link?.click?.();
        }, 500);
      },
    },
  );

  return (
    <Flex direction="column" flex={1} color="support.500" overflow="auto">
      <Flex alignItems="baseline" justify="space-between">
        <Heading fontSize="24px">Scans</Heading>
        <Flex align="flex-end">
          <Button
            mr={2}
            minW="200px"
            onClick={() => {
              mutate();
            }}>
            <MdFileUpload fontSize={'1.2rem'} />
            Export Info
          </Button>
          {!isExporting && Boolean(data) && (
            <CSVLink
              data={data}
              ref={csvRef}
              filename={`washhub-${selectedWashHub?.name}-scans.csv`}
              target="_blank"
            />
          )}
          <UserPill />
        </Flex>
      </Flex>
      <DateRangeInputExt
        startDate={startDate}
        endDate={endDate}
        onSearchClear={onSearchClear}
        onSearchPress={onSearchPress}
      />
      <Box pt={5}>
        <StatCards
          isScans
          hideValue
          type="items"
          selected={status}
          onSelectStatus={(_selected) => {
            if (Array.isArray(_selected)) {
              pagination.setPage(1);
              setStatus(_selected);
            }
          }}
        />
      </Box>
      <Filters
        venue={venue}
        isFullButton
        onApplyFilters={onApplyFilters}
        onClearFilters={onClearFilters}
      />
      <DataTable<Scan>
        mt={'0'}
        minW="1600px"
        data={scans}
        columns={scansColumns}
        pagination={pagination}
        isLoading={isLoading}
        onRowClick={(scan) => {
          navigate(`${scan.scanId}`, { state: scan });
        }}
        renderEmpty={() => (
          <Center p={8}>
            <Text fontSize="20px">No Scans available</Text>
          </Center>
        )}
      />
    </Flex>
  );
};

export default ScansView;
